
import { HttpHeaders } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/services/apiService';
import { SweetAlertService } from 'src/services/sweetAlertService';
import jwt_decode from "jwt-decode";
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/services/auth.service';
import { jamarekObj } from 'src/app/models/jamarekObj';
import { JamarekTaxType } from 'src/app/models/ItemType';
import { CustomValidators } from 'src/app/validator/custom-validators';

@Component({
  selector: 'app-jamarek',
  templateUrl: './jamarek.component.html',
  styleUrls: ['./jamarek.component.css']
})
export class JamarekComponent {

  form!: FormGroup;
  statisticalUnits:any[]=[];
  taxList:any[]=[];
  units:any[][] = [];
  taxUnits:any[][] = [];
  carbonCopyId:string|undefined;
  hideadditionalCode=false;
  formSubmited:boolean=false;
  isLoading=true;
  formType:string="1";
  showJamarek=true;
  showTax=true;

  showSaveBtn=true;  
  isEmployee=false;
  token:string="";
  mainPath = "" // قراءة القيمة من environment

  applicationNumber?:string|undefined="0";

  public exemptAssetsList:any[]=[];

  

  getExemptAssetsList(){

    

    var request=this.apiService.get("Moin/GetFindings",`${environment.govnet}`,undefined,this.token);

    request.subscribe(response=>{
      var data=response.data.list as any[];

      var newList= data.map(item=>{

        var value=  item.value as string;

        var newValue=value.substring(0,50);

        return  {
          key:item.key,
          value:newValue,
        }

      });

      this.exemptAssetsList=newList;

    });
  }

  constructor(private fb: FormBuilder,private apiService:ApiService,private authService:AuthService,
    private route: ActivatedRoute,private alertService:SweetAlertService) {
      this.mainPath= environment.MainPath;

    document.addEventListener('scroll', (event) => {
      event.stopPropagation();  // Be cautious, as this can stop all scroll events in the document
    }, true);

    this.token= this.route.snapshot.queryParamMap.get('Token')!;
    
    this.getExemptAssetsList();
    this.fillStaticUnit();


    if(this.route.snapshot.queryParams['Token'] && this.route.snapshot.queryParams['Carponcopyid']){

      this.carbonCopyId= this.route.snapshot.queryParamMap.get('Carponcopyid')!;
      this.formType= this.route.snapshot.queryParamMap.get('formType')!;
      this.applicationNumber = this.route.snapshot.queryParamMap.get('ApplicationNumber')??"0";
      
      if(this.formType=="2"){

        var showingType = this.route.snapshot.queryParamMap.get('show')!;

        if(showingType=="jamarek"){

          this.showJamarek=true;
          this.showTax=false;

        }else if(showingType=="tax"){

          this.showJamarek=false;
          this.showTax=true;

        }


      }

      this.checkValidty();

      this.fillApplicant(this.carbonCopyId);

      var TaxNumber = this.route.snapshot.queryParamMap.get('TaxNumber')!;


      if(!this.isNumber(TaxNumber)){
        this.alertService.ShowAlert('error','الرقم الضريبي غير صحيح');
      }

      this.form = this.fb.group({
        taxNumber:[TaxNumber, Validators.required],
        formItems: this.fb.array([]),
        taxItems: this.fb.array([]),
      });

      var token = this.route.snapshot.queryParamMap.get('Token')!;

      var decoded = jwt_decode(token) as any;

      if(decoded.role!="CONSUMER"){
        this.isEmployee=true;
      }
      
      this.hideadditionalCode=true;

    }else{
      location.href="/"+this.mainPath+"/Dashboard";
    }

  }


  isNumber(value?: string | number): boolean
  {
    return ((value != null) &&
            (value !== '') &&
            !isNaN(Number(value.toString())));
  }

  fillApplicant(carbonId:string){

    var request=this.apiService.get('Moin/GetJamarekTaxApplicantData?licenseId='+carbonId,`${environment.govnet}`,undefined,this.token);;

    request.subscribe(response=>{

      var jamarekImtems=response.data.jamarek as any[];

      var taxImtems=response.data.tax as any[];

      if(jamarekImtems.length>0){

        this.form.get('taxNumber')?.setValue(jamarekImtems[0].taxNumber);

        jamarekImtems.map((item,index)=>{

          var obj=new jamarekObj(item.id,item.searchKeyword,item.hsCode,item.remainingQuantity,item.statisticalUnit,item.additionalCode,item.exemptAssets,true,item.totalPrice,item.description,item.credits,item.note);
          var form= this.generateItem(JamarekTaxType.Jamarek,obj);
          this.searchEnquiry(item.searchKeyword,index);
          this.addItemWithValue(form);

          this.isLoading=false;

        })
      }else{
        this.isLoading=false;
      }

      if(taxImtems.length>0){

        this.form.get('taxNumber')?.setValue(taxImtems[0].taxNumber);

        taxImtems.map((item,index)=>{

          var obj=new jamarekObj(item.id,item.searchKeyword,item.hsCode,item.remainingQuantity,item.statisticalUnit,item.additionalCode,item.exemptAssets,true,item.totalPrice,item.description,'','');
          var form= this.generateItem(JamarekTaxType.Tax,obj);
          //this.searchTaxEnquiry(item.searchKeyword,index);
          this.addTaxItemWithValue(form);

          this.isLoading=false;

        })
      }else{

        this.isLoading=false;

      }

    });

  }

  checkValidty(){



    var request=this.apiService.get(`Moin/GetEditFormByConsumerStatus?carbonId=${this.carbonCopyId}`,`${environment.govnet}`,undefined,this.token);;

    request.subscribe(response=>{

      this.isLoading=false;

      if(response.data.value==true){
        
        this.showSaveBtn=false;
        
      }
    });

  }

  generateItem(itemTybe:JamarekTaxType,data?: {
    id?: number;
    unitName?: string;
    unitId?: string;
    quantity?: string;
    exemptAssets?: string;
    staticUnit?: string;
    additionalCode?: number;
    hsCode?: boolean;
    totalPrice: number;
    description: string;
    credits: string;
  }): FormGroup {

  
    return this.fb.group({
      id: [data?.id ||0],
      unitName: [data?.unitName || '', Validators.required],
      unitId: [data?.unitId || '', [Validators.required]],
      quantity: [data?.quantity || '1', [Validators.min(1),Validators.required]],
      exemptAssets: [ data?.exemptAssets  || '',  (itemTybe==JamarekTaxType.Tax) ? Validators.required:false],
      staticUnit: [data?.staticUnit || '', Validators.required],
      additionalCode: [data?.additionalCode || ''],
      hsCode: [data?.unitId || ''],
      totalPrice: [data?.totalPrice || '1', [Validators.min(1),Validators.required]],
      description: [data?.description || '' , [Validators.required,CustomValidators.emptyStringValidator]],
      credits: [data?.credits || ''],
    });
    
  }

  get Items() {
    return this.form.get('formItems') as FormArray;
  }

  get TaxItems() {
    return this.form.get('taxItems') as FormArray;
  }

  addItem() {
    
    this.Items.push(this.generateItem(JamarekTaxType.Jamarek));
  }

  addItemWithValue(data:FormGroup) {
    this.Items.push(data);
  }


  removeJamarek(index: number) {
    this.Items.removeAt(index);
  }

  removeTax(index: number) {
    this.TaxItems.removeAt(index);
  }

  addTaxItem() {
    this.TaxItems.push(this.generateItem(JamarekTaxType.Tax,{hsCode:false,staticUnit:"",unitId:"1",totalPrice:0,credits:'0',description:''}));
  }

  addTaxItemWithValue(data:FormGroup) {
    this.TaxItems.push(data);
  }

  
  onSubmit() {

    if(!this.isNumber(this.form.get('taxNumber')?.value)){
      this.alertService.ShowAlert('error','الرقم الضريبي غير صحيح');
      return;
    }

    this.formSubmited=true;

    if(this.form.valid){

      this.showSaveBtn=false;

      this.formSubmited=false;

      this.isLoading=true;

      var gamarekExemptionReqest:any[]=[];

      var taxExemptionReqest:any[]=[];

      let items = this.Items;
      let taxItems = this.TaxItems;

      var canSubmit=true;

      items.controls.forEach((control, index) => {

        let searchText= $(`#unitId-${index} option:selected`).text();

        if(searchText=='يرجى الاختيار'){
          
          this.alertService.ShowAlert('warning','يرجى التأكد من اختيار جميع العناصر');

          this.isLoading=false;
          this.showSaveBtn=true;
          canSubmit= false;
        }
      });

      if(canSubmit){
        items.controls.forEach((control, index) => {

          let searchText= $(`#unitId-${index} option:selected`).text();
  
          var data={
            "id": control.get('id')?.value,
            "ssCode": control.get('unitId')?.value,
            "quantity": control.get('quantity')?.value,
            "statisticalUnit": control.get('staticUnit')?.value,
            "exemptAssets": control.get('exemptAssets')?.value,
            "additionalCode":control.get('additionalCode')?.value ,
            "description":control.get('description')?.value ,
            "credits":control.get('credits')?.value ,
            "searchKeyword": searchText,
            "totalPrice": control.get('totalPrice')?.value
          };
  
          gamarekExemptionReqest.push(data);
        });
  
        taxItems.controls.forEach((control, index) => {
  
          //let searchText= $(`#texunitId-${index} option:selected`).text();
  
          var data={
            "id": control.get('id')?.value,
            "ssCode": control.get('unitId')?.value,
            "quantity": control.get('quantity')?.value,
            "statisticalUnit": control.get('staticUnit')?.value,
            "exemptAssets": control.get('exemptAssets')?.value,
            "description":control.get('description')?.value ,
            "additionalCode":control.get('additionalCode')?.value ,
            "searchKeyword": control.get('unitName')?.value,
            "totalPrice": control.get('totalPrice')?.value
          };
  
          taxExemptionReqest.push(data);
        });
  
        var body={
          "model":{
            "carponcopyid": this.carbonCopyId,
            "taxNumber": this.form.get('taxNumber')?.value,
            "userId":this.authService.getNationalNumber(),
            "jamarekItems": gamarekExemptionReqest,
            "taxItems":taxExemptionReqest,
            "userType":"1",
            "applicationNumber":this.applicationNumber,
          }
        }
  
        var request=this.apiService.post('Moin/SubmitExemptionForm',body,`${environment.govnet}`,undefined,this.token);;
  
          request.subscribe(response=>{
            if(response){
  
              this.isLoading=false;
  
  
              if(response.data.value==true){
              
                this.alertService.ShowAlert('success',' تم الحفظ بنجاح');
              }else{
                this.showSaveBtn=true;
              }
            }
          });
  
      }


    }else{
      console.log(this.form);
    }
  }

  


  fillStaticUnit(){


    var request= this.apiService.get('Moin/GetStatisticalUnits' , `${environment.govnet}`,undefined,this.token);;

    request.subscribe(response=>{
      var list=response.data.list;
      this.statisticalUnits=list;
    });

  }

  async getUnits(event:Event, index: number){
    
    const inputElement = event.target as HTMLInputElement; // Type assertion
    const text = inputElement.value;


    await this.searchEnquiry(text, index,true);

  }

  // async getTaxUnits(event:Event, index: number){
    
  //   const inputElement = event.target as HTMLInputElement; // Type assertion
  //   const text = inputElement.value;


  //   await this.searchTaxEnquiry(text, index);

  // }


  private searchEnquiry(text: string, index: number,refresh:boolean=false) {

    if(refresh){
      this.isLoading=true;
    }

    var request = this.apiService.get('Moin/GeneralEnquiry?description=' + text, `${environment.govnet}`,undefined,this.token);;

    request.subscribe(response => {

      this.isLoading=false;

      this.units[index] = response.data.list as any[];
    });
  }

  onUnitIdChange(event: any, index: number) {
    const selectedUnitId = event.target.value;

    this.Items.controls.map(control=>{

      if(control.get('hsCode')?.value==selectedUnitId){

          this.alertService.ShowAlert('error','لا يمكن تكرار نفس العنصر');

          this.removeJamarek(index);

          return;

      }

    });


  
    const selectedUnit = this.units[index].find(unit => unit.key === selectedUnitId);

    if (selectedUnit) {
      const itemsArray = this.form.get('formItems') as FormArray;
      const itemGroup = itemsArray.at(index) as FormGroup;

      itemGroup.get('hsCode')?.setValue(selectedUnit.key);


    }
  }

  onTaxUnitIdChange(event: any, index: number) {
    const selectedUnitId = event.target.value;
  
    const selectedUnit = this.taxUnits[index].find(unit => unit.key === selectedUnitId);

    if (selectedUnit) {
      const itemsArray = this.form.get('taxItems') as FormArray;
      const itemGroup = itemsArray.at(index) as FormGroup;

      itemGroup.get('hsCode')?.setValue(selectedUnit.key);


    }
  }

  


}

